import { IGetProject } from '../../model/IGetProject';
import { IGetDataset } from '../../model/IGetDataset';

export const DATASETTYPE = 'datasetType';
export const DATASETFORMAT = 'datasetFormat';

export const isDataset = (item: IGetDataset | IGetProject) => {
  return DATASETFORMAT in item;
};
